import { render, staticRenderFns } from "./courseSearchStudio.vue?vue&type=template&id=17892a51"
import script from "./courseSearchStudio.vue?vue&type=script&lang=js"
export * from "./courseSearchStudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports